import { useMutation, useQuery } from "@tanstack/react-query";
import { getBusinessContext, patchBusinessContext } from "../services/businessContext/businessContextEndpoints";
import type { BusinessContext, BusinessContextPatch } from "../types/businessContext";
import { queryClient } from "./QueryHooks";

export function useBusinessContext(workspaceId: string) {
  return useQuery<BusinessContext, any>({
    queryKey: ["businessContext", workspaceId],
    queryFn: async () => {
      const res = await getBusinessContext({ workspace_id: workspaceId });
      return (res as any).data ?? res; // axios response shape
    },
    enabled: !!workspaceId,
    staleTime: 60_000,
  });
}

export function useUpdateBusinessContext(workspaceId: string) {
  return useMutation<BusinessContext, any, BusinessContextPatch>({
    mutationFn: async (patch: BusinessContextPatch) => {
      const res = await patchBusinessContext({ workspace_id: workspaceId, patch });
      return (res as any).data ?? res;
    },
    onSuccess: (data) => {
      queryClient.setQueryData(["businessContext", workspaceId], data);
    },
  });
}
